import Icon from '../components/Icon.vue'

Icon.register({
  'pen-fancy': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M79.2 282.9A32-32 0 0 1 58.9 303.2L0 480 4.7 484.7 97.6 391.8C96.9 389.2 96 386.8 96 384 96 366.3 110.3 352 128 352S160 366.3 160 384 145.7 416 128 416C125.2 416 122.8 415.1 120.2 414.4L27.3 507.3 32 512 208.8 453.1A32-32 0 0 1 229.1 432.8L262.1 348.8 163.3 249.9 79.2 282.9zM369.3 28.3L186.1 227.8 284 325.7 483.5 142.5C568.4 67.5 443.7-55.9 369.3 28.3z'
      }
    ]
  }
})
